import React from "react";

const FeatureCard = ({ image, title, subtitle, description }) => {
  return (
    <div className="flex flex-col gap-4 bg-grey-01 p-6 rounded-md">
      <img src={image} alt={title} className="w-8 h-8 md:w-10 md:h-10" />

      <div className="flex flex-col gap-2">
        <p className="flex flex-col gap-1">
          <h4 className="!font-medium text-grey-08 !text-[16px] md:!text-[20px]">
            {title}
          </h4>
          <span className="text-purple-06 h4 !font-medium !text-[12px]">
            {subtitle}
          </span>
        </p>

        <p className="text-grey-05 b4">{description}</p>
      </div>
    </div>
  );
};

export default FeatureCard;
